import { UnsignedPublicKey, WrappedPrivateKey } from "@box/common/key-management/types";
import { Utils } from "@box/common/platform/misc/utils";
import { SignedPublicKey } from "@box/sdk-internal";

export class PublicKeyEncryptionKeyPairRequestModel {
  wrappedPrivateKey: WrappedPrivateKey;
  publicKey: string;
  signedPublicKey: SignedPublicKey | null;

  constructor(
    wrappedPrivateKey: WrappedPrivateKey,
    publicKey: UnsignedPublicKey,
    signedPublicKey: SignedPublicKey | null,
  ) {
    this.wrappedPrivateKey = wrappedPrivateKey;
    this.publicKey = Utils.fromBufferToB64(publicKey);
    this.signedPublicKey = signedPublicKey;
  }
}
